import {
    BACKEND,
    apiEndpoint,
} from '../utils/api';

const backendEndpoint = apiEndpoint({
    api: BACKEND,
    endpoint: 'action/log',
});

export async function logAction(action, params = {}) {
    return backendEndpoint.post('', { action, params });
}
